import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { NoGraphDataSvg, LoadingIndicatorSvg } from 'components/icons';

export const CustomChart = (props) => {
  const { completedInspectionsStats, loadingCompletedInspectionsStats } = props;

  const options = {
    responsive: true,
    cutoutPercentage: 75,
    tooltips: {
      // Disable the on-canvas tooltip
      enabled: false,

      custom: function (tooltipModel) {
        // Tooltip Element
        var tooltipEl = document.getElementById('chartjs-tooltip');

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.id = 'chartjs-tooltip';
          tooltipEl.innerHTML = '<table></table>';
          document.body.appendChild(tooltipEl);
        }

        // Hide if no tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0;
          return;
        }

        // Set caret Position
        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
          tooltipEl.classList.add('no-transform');
        }

        function getBody(bodyItem) {
          return bodyItem.lines.map(line => {
            return `${line.split(': ')[1]} inspections completed by ${line.split(': ')[0]}`
          });
        }

        // Set Text
        if (tooltipModel.body) {
          var titleLines = tooltipModel.title || [];
          var bodyLines = tooltipModel.body.map(getBody);

          var innerHtml = '<thead>';

          titleLines.forEach(function (title) {
            innerHtml += '<tr><th>' + title + '</th></tr>';
          });
          innerHtml += '</thead><tbody>';

          bodyLines.forEach(function (body, i) {
            innerHtml += '<tr><td style=\'color: #FFFFFF;\' >' + body + '</td></tr>';
          });
          innerHtml += '</tbody>';

          var tableRoot = tooltipEl.querySelector('table');
          tableRoot.innerHTML = innerHtml;
        }

        // `this` will be the overall tooltip
        var position = this._chart.canvas.getBoundingClientRect();

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1;
        tooltipEl.style.borderRadius = '6px';
        tooltipEl.style.background = '#04333B';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.zIndex = 10;
        tooltipEl.style.padding = '5px 12px';
        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipEl.style.pointerEvents = 'none';
      }
    },
    legend: {
      display: false,
    },
  };

  let completedByTech = completedInspectionsStats.filter(i => i.completed_by_type === 'tech');
  let completedByAdmin = completedInspectionsStats.filter(i => i.completed_by_type === 'admin');
  let completedByResident = completedInspectionsStats.filter(i => i.completed_by_type === 'tenant');

  const data = {
    labels: ["technicians", "admins", "residents"],
    datasets: [
      {
        data: loadingCompletedInspectionsStats ? [] : [completedByTech?.length ?? 0, completedByAdmin?.length ?? 0, completedByResident?.length ?? 0],
        backgroundColor: ["#04333B", "#1DBD6B", "#C7EFDA"],
        hoverBackgroundColor: ['#122D34', '#1AAA60', '#A5E5C4'],
        borderWidth: 0,
      },
    ],
  };

  return (
    <div style={{ width: '200px', height: '200px', position: 'relative' }} >
      <Doughnut data={data} width='100%' height='100%' options={options} />
      {
        completedInspectionsStats.length === 0 && !loadingCompletedInspectionsStats &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <NoGraphDataSvg inspectionsAnalytics />
        </div>
      }
      {
        (completedInspectionsStats.length > 0) && !loadingCompletedInspectionsStats &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center' style={{ pointerEvents: 'none', textAlign: 'center' }}>
          <div>
            <div style={{ fontSize: 32, color: '#04333B' }}>{`${completedInspectionsStats.filter(i => ['admin', 'tenant', 'tech'].includes(i.completed_by_type))?.length ?? 0}`}</div>
            <div style={{ fontSize: 14, color: '#04333B' }}>Total</div>
          </div>
        </div>
      }
      {loadingCompletedInspectionsStats &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <LoadingIndicatorSvg />
        </div>
      }
    </div >
  )
}
